import {charcoal} from '../../sass/v2/_exports.sass';

export const MapIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0001 18.6667C18.9414 18.6667 21.3334 16.2747 21.3334 13.3333C21.3334 10.392 18.9414 7.99999 16.0001 7.99999C13.0588 7.99999 10.6668 10.392 10.6668 13.3333C10.6668 16.2747 13.0588 18.6667 16.0001 18.6667ZM16.0001 10.6667C17.4708 10.6667 18.6668 11.8627 18.6668 13.3333C18.6668 14.804 17.4708 16 16.0001 16C14.5294 16 13.3334 14.804 13.3334 13.3333C13.3334 11.8627 14.5294 10.6667 16.0001 10.6667Z"
        fill={color}
      />
      <path
        d="M15.2268 29.0853C15.4525 29.2465 15.7228 29.3331 16.0001 29.3331C16.2774 29.3331 16.5478 29.2465 16.7735 29.0853C17.1788 28.7987 26.7055 21.92 26.6668 13.3333C26.6668 7.45199 21.8815 2.66666 16.0001 2.66666C10.1188 2.66666 5.33346 7.45199 5.33346 13.3267C5.29479 21.92 14.8215 28.7987 15.2268 29.0853ZM16.0001 5.33332C20.4121 5.33332 24.0001 8.92132 24.0001 13.34C24.0281 19.2573 18.1495 24.5707 16.0001 26.3133C13.8521 24.5693 7.97213 19.2547 8.00013 13.3333C8.00013 8.92132 11.5881 5.33332 16.0001 5.33332Z"
        fill={color}
      />
    </svg>
  );
};
